import classNames from "classnames";
import Styles from "./Footer.module.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faLine, faFacebook } from "@fortawesome/free-brands-svg-icons";
import Icon from "../Icon/Icon";

const Footer = () => {
  return (
    <div>
      <footer className={classNames("col-12", Styles.footer)}>
        <div className="container">
          <div className={classNames(Styles.footer__title)}>
            <h6>聯絡我們</h6>
          </div>
          <div className={classNames(Styles.footer__bottom)}>
            <div className={classNames(Styles.footer__param)}>
              <p >
                台內團字第1100043798號
                <br />
                聯絡電話：(03)853-0330
                <br />
                地址：花蓮縣吉安鄉文化七街20號
                <br />
                服務時間：周一至周五 8:00-17:00
              </p>
            </div>
            <div className={classNames(Styles.footer__icon)}>

              <a
                href={`https://line.me/R/ti/p/@336wnpqq`}
                target="_blank"
                rel="noopener noreferrer">

                <Icon className="__brand" iconName={faLine} />
              </a>

              <a
                href={`https://www.facebook.com/kuangpo0812/`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon className="__brand" iconName={faFacebook} />
              </a>
            </div>
          </div>
        </div>
      </footer>
      <div className={classNames(Styles.footer__copyright)}>
        ©社團法人中華廣博長照發展協會
      </div>
    </div>
  );
};
export default Footer;
